<template>
  <div class="wrapper" id="app">
    <p style="padding: 30px 0px 0px 30px; text-align: center; color: white;">
    <img src="https://vipvacaciones.com/img/blancoVIp.png" width="100" height="auto">
    </p>
    <p style="padding:  20px 20px 5px 20px; text-align: center; color: white; font-size: 24px;">REALIZA UN PAGO SEGURO</p>
    <p style="padding: 5px; text-align: center; color: white; font-size: 12px;">Al llenar este formulario usted acepta el uso de su tarjeta crédito
    para el pago por los productos/servcios en VIP VACACIONES.</p>
    <CardForm
      :form-data="formData"
      @input-card-code="updateCardCode"
      @input-card-number="updateCardNumber"
      @input-card-name="updateCardName"
      @input-card-month="updateCardMonth"
      @input-card-year="updateCardYear"
      @input-card-cvv="updateCardCvv"
    />
    <!-- backgroundImage="https://images.unsplash.com/photo-1572336183013-960c3e1a0b54?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2250&q=80" -->
  </div>
</template>

<script>
import CardForm from '@/components/CardForm'
export default {
  name: 'app',
  components: {
    CardForm
  },
  data () {
    return {
      formData: {
        cardCantidad: '',
        cardCode: '',
        cardName: '',
        cardNumber: '',
        cardMonth: '',
        cardYear: '',
        cardCvv: ''
      },
      tableButtonText: 'Solicitar',
      cartType: ''
    }
  },
  methods: {
    updateCardCode (val) {
    },
    updateCardButton (val) {
    },
    updateCardNumber (val) {
    },
    updateCardName (val) {
    },
    updateCardMonth (val) {
    },
    updateCardYear (val) {
    },
    updateCardCvv (val) {
    }
  },
  mounted () {
    this.$i18n.locale = navigator.language
  }
}
</script>

<style lang="scss">
@import '../src/assets/style.scss';
</style>
